import React from 'react';
import { useAppSelector } from 'store/hooks';

import { getCoursesLessons } from 'store/courses-lessons/actions';
import { coursesLessonsSelector } from 'store/courses-lessons/selectors';

import { DefaultModal } from 'components/DefaultModal';

import { usePagination } from 'hooks/usePagination';

import { useCoursesLessons } from './CoursesLessonsPage.hooks';

import CoursesLessonsPage from './CoursesLessonsPage';

const CoursesLessonsPageContainer = () => {
  const coursesLessons = useAppSelector(coursesLessonsSelector);

  const {
    viewMode,
    isRootAdmin,
    schoolsLoading,
    coursesLoading,
    loading,
    groupBy,
    currentGroupByOption,
    searchQuery,
    sortParams,
    showArchived,
    lessonGroups,
    tableColumns,
    showGroupHeaders,
    listQueryParams,
    schoolOptions,
    selectedSchoolOption,
    courseOptions,
    selectedCourseOption,
    removeConfirmOpen,
    removeConfirmData,
    attachDrawerOpen,
    selectedLessonForAttach,
    replaceDrawerOpen,
    selectedLessonForReplace,
    closeRemoveConfirm,
    onSearchChange,
    onShowArchivedChange,
    onGroupByChange,
    onSchoolChange,
    onCourseChange,
    onChangeCourseClick,
    onSortChange,
    onLessonRowClick,
    onLessonEditClick,
    onLessonRemoveClick,
    onLessonAttachClick,
    onLessonReplaceClick,
    onConfirmRemoveClick,
    onAttachDrawerClose,
    onReplaceDrawerClose,
    onAttachmentsChange,
  } = useCoursesLessons({
    lessons: coursesLessons.data,
    lessonsPerPage: coursesLessons.perPage,
    currentPage: coursesLessons.currentPage,
  });

  const [onPerPageChange, onPrevPageClick, onNextPageClick] = usePagination({
    dataAction: getCoursesLessons,
    data: { query: searchQuery, ...listQueryParams },
    currentPage: coursesLessons.currentPage,
    totalPages: coursesLessons.totalPages,
    perPage: coursesLessons.perPage,
    sortBy: sortParams.sortBy,
    sortDirection: sortParams.sortDirection,
  });

  return (
    <>
      <CoursesLessonsPage
        viewMode={viewMode}
        isRootAdmin={isRootAdmin}
        schoolsLoading={schoolsLoading}
        coursesLoading={coursesLoading}
        loading={loading}
        lessons={coursesLessons.data}
        groupBy={groupBy}
        currentGroupByOption={currentGroupByOption}
        lessonGroups={lessonGroups}
        tableColumns={tableColumns}
        showGroupHeaders={showGroupHeaders}
        sortParams={sortParams}
        currentPage={coursesLessons.currentPage}
        totalPages={coursesLessons.totalPages}
        perPage={coursesLessons.perPage}
        showArchived={showArchived}
        schoolOptions={schoolOptions}
        selectedSchoolOption={selectedSchoolOption}
        courseOptions={courseOptions}
        selectedCourseOption={selectedCourseOption}
        attachDrawerOpen={attachDrawerOpen}
        selectedLessonForAttach={selectedLessonForAttach}
        replaceDrawerOpen={replaceDrawerOpen}
        selectedLessonForReplace={selectedLessonForReplace}
        onSearchChange={onSearchChange}
        onShowArchivedChange={onShowArchivedChange}
        onGroupByChange={onGroupByChange}
        onSchoolChange={onSchoolChange}
        onCourseChange={onCourseChange}
        onChangeCourseClick={onChangeCourseClick}
        onSortChange={onSortChange}
        onPerPageChange={onPerPageChange}
        onPrevPageClick={onPrevPageClick}
        onNextPageClick={onNextPageClick}
        onLessonRowClick={onLessonRowClick}
        onLessonEditClick={onLessonEditClick}
        onLessonRemoveClick={onLessonRemoveClick}
        onLessonAttachClick={onLessonAttachClick}
        onLessonReplaceClick={onLessonReplaceClick}
        onAttachDrawerClose={onAttachDrawerClose}
        onReplaceDrawerClose={onReplaceDrawerClose}
        onAttachmentsChange={onAttachmentsChange}
      />
      <DefaultModal
        {...removeConfirmData}
        open={removeConfirmOpen}
        confirmText="Yes, remove"
        onConfirmClick={onConfirmRemoveClick}
        onCancelClick={closeRemoveConfirm}
        onClose={closeRemoveConfirm}
      />
    </>
  );
};

export default CoursesLessonsPageContainer;
